export default "__VITE_ASSET__DCfXoBLk__"